import { getGitHubInstallations } from "@/api/useIntegrations.selector"
import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { GitHubConfigurationItem } from "./GitHubConfigurationItem"
import { GITHUB_KEY_PREFIX } from "./GitHubConfigurationPage.constants"

import type { GitHubConfigurationTabProps } from "."

export const GitHubConfigurationTab = (props: GitHubConfigurationTabProps) => {
  const keyPrefix = `${GITHUB_KEY_PREFIX}.`
  const { t } = useTranslation()
  const [data] = useIntegration(props)
  const installations = getGitHubInstallations(data?.configuration)
  const noData = !installations.length

  return (
    <>
      {noData && t(`${keyPrefix}noInstallations`)}
      {!noData &&
        installations.map(
          ({ organizationName: name, installationId, ...rest }) => {
            return (
              <GitHubConfigurationItem
                key={installationId}
                keyPrefix={keyPrefix}
                values={{ name, id: `${installationId}`, ...rest }}
                {...props}
              />
            )
          }
        )}
    </>
  )
}
